module.exports = __webpack_public_path__ + "img/starCircle2.68c5fbcc.svg";